import appConfigs from "@configs/app";
import httpClient from "@plugins/http";
import { ApiResponse } from "@apis/api.ts";
import { ShortcutKey } from "@modules/app/v2/shortcut-types.ts";
import { cookieManager } from "@utils/cookie.manager.ts";
import { shortcutSaveRequest } from "@modules/user-preference/user-preference-types.ts";

interface ShortcutsResult {
  shortcuts: ShortcutKey[];
}

interface HomepageResult {
  displayNewHomepage: boolean;
}

interface HomepageRequest {
  displayNewHomepage: boolean;
}

export const getSignedUrl = async (): Promise<ApiResponse<string>> => {
  return httpClient.get(`/apis/user/preference/generate-signed-url`);
};

export const getShortcuts = async (
  userUuid: string,
  userHash: string,
  requestParams: URLSearchParams,
): Promise<ApiResponse<ShortcutsResult>> => {
  return httpClient.get(`/preference/user/${userUuid}/${userHash}/shortcuts.json`, {
    baseURL: `${appConfigs.s3ResourceDomain}`,
    headers: { Accept: "application/json" },
    withCredentials: true,
    params: requestParams,
  });
};

export const getHomepage = async (
  userUuid: string,
  userHash: string,
  requestParams: URLSearchParams,
): Promise<ApiResponse<HomepageResult>> => {
  return httpClient.get(`/preference/user/${userUuid}/${userHash}/homepage.json`, {
    baseURL: `${appConfigs.s3ResourceDomain}`,
    headers: { Accept: "application/json" },
    withCredentials: true,
    params: requestParams,
  });
};

export const saveHomepage = async (payload: HomepageRequest): Promise<ApiResponse<void>> => {
  const token = cookieManager.getCookie("jwt_token");

  if (!token) {
    throw new Error("Access Denied: No jwt token found");
  }
  const payloadParam = new URLSearchParams({
    displayNewHomepage: String(payload.displayNewHomepage),
  });

  return httpClient.post("/preference/homepage", payload, {
    baseURL: `${appConfigs.userApiBaseUrl}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params: payloadParam,
  });
};

export const saveShortcuts = async (payload: shortcutSaveRequest): Promise<ApiResponse<void>> => {
  const token = cookieManager.getCookie("jwt_token");

  if (!token) {
    throw new Error("Access Denied: No jwt token found");
  }

  return httpClient.post(`/preference/shortcuts`, payload, {
    baseURL: `${appConfigs.userApiBaseUrl}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};
